import TableRow from "./TableRow";
import type { SubscriptionTableColumn, SubscriptionTableRow } from "./types";

interface TableBodyProps {
    rows: SubscriptionTableRow[];
    columns: SubscriptionTableColumn[];
    onCellSave?: (rowId: string | number, columnId: string, value: any) => void;
}

const TableBody = ({ rows, columns, onCellSave }: TableBodyProps) => {
    return (
        <tbody>
            {rows.map((row) => (
                <TableRow key={row.id} row={row} columns={columns} onCellSave={onCellSave} />
            ))}
        </tbody>
    );
};

export default TableBody;
